import { fetchDataAndProceed } from '../../config/utils';
import { METHOD_TYPES } from '../../config/constants';

export const getChatHistory = (data, callback) => {
  return fetchDataAndProceed('/admin/v1/chatLogs/filtersQuery', METHOD_TYPES.POST, data, callback, 0);
};

export const getCurrentChatHistory = (data, callback) => {
  return fetchDataAndProceed('/admin/v1/chatLogs/chatLogsBySessionId', METHOD_TYPES.POST, data, callback);
};

export const updateCustumAgentNoteForm = (data, callback) => {
  return fetchDataAndProceed('/admin/v1/customAgentNotes', METHOD_TYPES.PUT, data, callback);
};

export const updateReviewStatusInHistory = (data, callback) => {
  return fetchDataAndProceed('/admin/v1/chatLogs/reviewstatus', METHOD_TYPES.PUT, data, callback);
};


// WEBPACK FOOTER //
// ./src/data/redux/history_details/api.js